import { render } from "./PanelOptionActivator.vue?vue&type=template&id=347786c5&lang=pug"
import script from "./PanelOptionActivator.vue?vue&type=script&lang=js"
export * from "./PanelOptionActivator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__